import { Box, Card, IconButton, Stack, Typography } from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FileIcon from '@product-framework/components/FormFields/NotesAttachment/FileIcon';
import { getFileExtension, getFormattedFileSize } from '@ui-framework/index';
import { toLongDate } from '@utils/Dated';

function AttachmentCard({
  attachment,
  canRemove = false,
  formatMessage,
  onView,
  onDownload,
  onDelete,
}) {
  return (
    <Card key={attachment.id} variant="outlined" sx={{ p: 1.25 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <FileIcon color="primary" ext={getFileExtension(attachment.fileName)} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="body2" noWrap>
            {attachment.fileName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {formatMessage({
              id: `ISSUES_ATTACHMENT_TYPE_${attachment.attachmentType}`,
              defaultMessage: attachment.attachmentType,
            })}{' '}
            ·{' '}
            {attachment.sizeBytes == null
              ? '-'
              : getFormattedFileSize(attachment.sizeBytes)}{' '}
            ·{' '}
            {attachment.createdDateTime
              ? toLongDate(attachment.createdDateTime)
              : '-'}
          </Typography>
        </Box>
        <IconButton size="small" onClick={() => onView(attachment)}>
          <RemoveRedEyeIcon color="primary" fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={() => onDownload(attachment)}>
          <CloudDownloadIcon color="primary" fontSize="small" />
        </IconButton>
        {canRemove && (
          <IconButton size="small" onClick={() => onDelete(attachment)}>
            <Delete color="error" fontSize="small" />
          </IconButton>
        )}
      </Stack>
    </Card>
  );
}

export default AttachmentCard;
